import { render, staticRenderFns } from "./admin_tools_dashboard.vue?vue&type=template&id=03b74036&scoped=true&"
import script from "./admin_tools_dashboard.vue?vue&type=script&lang=js&"
export * from "./admin_tools_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin_tools_dashboard.vue?vue&type=style&index=0&id=03b74036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b74036",
  null
  
)

export default component.exports